import { configureStore } from '@reduxjs/toolkit';
import Menu from "../components/Menu/store/menuSlice";
import Disputes from "../components/DisputeManagement/store/disputesSlice";
import Promotions from "../components/Promotions/store/promotionsSlice";
import RoleManagement from "../components/RoleManagement/store/roleManagementSlice";
import Theme from "./Theme";
import merchants from "../components/Merchants/store/merchantsUserSlice";
import merchantAnalytics from "../components/Analytics/MerchantAnalytics/store/merchantAnalyticsSlice";
import merchantAnalyticsOverview from "../components/Analytics/MerchantAnalytics/store/merchantAnalyticsOverviewSlice";
import salesDetailed from "../components/Analytics/SalesDetailedView/store/salesDetailedSlice";
import categorySales from "../components/Analytics/CategorySales/store/categorySalesSlice";
import itemSales from "../components/Analytics/ItemSales/store/itemSalesSlice";
import trendingItems from "../components/Analytics/TrendingItems/store/trendingItemsSlice";
import Settings from "../components/Settings/store/settingsSlice";
import deliveryCostAnalysis from "../components/Analytics/DeliveryCostAnalysis/store/deliveryCostAnalysisSlice";
import profitMargins from "../components/Analytics/ProfitMargins/store/profitMarginsSlice";
import itemPerformanceComparison from "../components/Analytics/ItemPerformanceComparison/store/itemPerformanceComparisonSlice";
import customers from "../components/Analytics/Customers/store/customersSlice";
import popularItems from "../components/Analytics/PopularItems/store/popularItemsSlice";
import customRangeReports from "../components/Reports/CustomRangeReports/store/customRangeReportsSlice";
import weeklyReports from "../components/Reports/WeeklyReports/store/weeklyReportsSlice";
import monthlyReports from "../components/Reports/MonthlyReports/store/monthlyReportsSlice";
import merchantEarnings from "../components/Reports/MerchantEarnings/store/merchantEarningsReportsSlice";
import activeSessionsAndDevices from "../components/Analytics/ActiveSessionsAndDevices/store/activeSessionsAndDevicesSlice";
import actionLogs from "../components/ActionLogs/store/actionLogsSlice";
import stores from "../components/Stores/store/userStoresSlice";
import deviceTypes from "../components/DeviceTypes/store/deviceTypesSlice";
import devices from "../components/Devices/store/devicesSlice";
import loyalty from "../components/Loyalty/store/loyaltySlice";
import auth from "../components/auth/store/authSlice";
import staffDashboard from "../components/Staff/store/staffDashboardSlice";
import managerReports from "../components/Reports/ManagerReports/store/managerReportsSlice";
import staffReports from "../components/Reports/StaffReports/store/staffReportsSlice";
import adminReportsReducer from "../components/Reports/AdminReports/store/adminReportsSlice";
import orders from "../components/Orders/store/ordersSlice";
import deviceAssignment from "../components/DeviceAssignment/store/deviceAssignmentSlice";
import adminDashboard from "../components/Dashboard/store/adminDashboardSlice";
import schedules from "../components/Schedules/store/schedulesSlice";
import merchantCategories from "../components/MerchantCategories/store/merchantCategoriesSlice";
import payments from "../components/Payments/store/paymentsSlice";
import adminAnalytics from "../components/Analytics/AdminAnalytics/store/adminAnalyticsSlice";
import merchantEarningsOverview from "../components/Admin/MerchantEarningsOverview/store/merchantEarningsSlice";
import emailTestModal from "../components/EmailTemplates/store/emailTestModalSlice";
import emailTemplateTest from "../components/EmailTemplates/store/emailTemplateTestSlice";

export const store = configureStore({
    reducer: {
        menu: Menu,
        disputes: Disputes,
        promotions: Promotions,
        roleManagement: RoleManagement,
        theme: Theme,
        merchants: merchants,
        merchantAnalytics: merchantAnalytics,
        merchantAnalyticsOverview: merchantAnalyticsOverview,
        salesDetailed: salesDetailed,
        categorySales: categorySales,
        itemSales: itemSales,
        trendingItems: trendingItems,
        settings: Settings,
        deliveryCostAnalysis: deliveryCostAnalysis,
        profitMargins: profitMargins,
        itemPerformanceComparison: itemPerformanceComparison,
        customers: customers,
        popularItems: popularItems,
        customRangeReports: customRangeReports,
        weeklyReports: weeklyReports,
        monthlyReports: monthlyReports,
        merchantEarnings: merchantEarnings,
        activeSessionsAndDevices: activeSessionsAndDevices,
        actionLogs: actionLogs,
        stores: stores,
        deviceTypes: deviceTypes,
        devices: devices,
        loyalty: loyalty,
        auth: auth,
        staffDashboard: staffDashboard,
        managerReports: managerReports,
        staffReports: staffReports,
        adminReports: adminReportsReducer,
        orders,
        deviceAssignment,
        adminDashboard,
        schedules,
        merchantCategories,
        payments,
        adminAnalytics,
        merchantEarningsOverview,
        emailTestModal,
        emailTemplateTest,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;

